export default __webpack_public_path__ + "static/media/product-icon.700d6c5d.svg";